<div class="container-fluid inventory-page">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
    <div>
      <div class="eyebrow">Root Inventory</div>
      <h2 class="mb-1">Current Inventory</h2>
      <div class="text-muted">Manual counts shown on the internal dashboard</div>
    </div>
    <a class="btn btn-outline-secondary" routerLink="/internal-dashboard">
      <i class="ri-arrow-left-line me-1"></i> Dashboard
    </a>
  </div>

  <div *ngIf="loading" class="card inventory-card"><div class="card-body">Loading inventory...</div></div>
  <div *ngIf="message" class="alert alert-success">{{ message }}</div>
  <div *ngIf="error" class="alert alert-warning">{{ error }}</div>

  <form *ngIf="!loading" class="inventory-stack" (ngSubmit)="save()">
    <div class="summary-grid">
      <div class="summary-card">
        <span>Manual Inventory</span>
        <strong>{{ totalManualInventory | number:'1.0-0' }}</strong>
        <small>{{ totalBoards }} boards &middot; {{ totalCabinets }} cabinets &middot; {{ totalKiosks }} kiosks</small>
      </div>
      <div class="summary-card route">
        <span>Fortune Route Machines</span>
        <strong>{{ routeMachines.total | number:'1.0-0' }}</strong>
        <div class="state-breakdown" *ngIf="routeMachines.byState.length; else noRouteMachines">
          <small *ngFor="let item of routeMachines.byState">{{ item.state }} {{ item.machines | number:'1.0-0' }}</small>
        </div>
        <ng-template #noRouteMachines>
          <small>No route machines found</small>
        </ng-template>
      </div>
    </div>

    <div class="card inventory-card">
    <div class="card-body">
      <div class="state-section">
        <div class="state-header">
          <h5>TX Inventory</h5>
          <span>{{ (inventory.txBoards || 0) + (inventory.txCabinets || 0) + (inventory.txKiosks || 0) | number:'1.0-0' }} total</span>
        </div>
        <div class="inventory-grid">
          <label>
            <span>Boards</span>
            <input class="form-control" type="number" min="0" name="txBoards" [(ngModel)]="inventory.txBoards" [disabled]="!isRoot">
          </label>
          <label>
            <span>Cabinets</span>
            <input class="form-control" type="number" min="0" name="txCabinets" [(ngModel)]="inventory.txCabinets" [disabled]="!isRoot">
          </label>
          <label>
            <span>Kiosks</span>
            <input class="form-control" type="number" min="0" name="txKiosks" [(ngModel)]="inventory.txKiosks" [disabled]="!isRoot">
          </label>
        </div>
      </div>

      <div class="state-section">
        <div class="state-header">
          <h5>GA Inventory</h5>
          <span>{{ (inventory.gaBoards || 0) + (inventory.gaCabinets || 0) + (inventory.gaKiosks || 0) | number:'1.0-0' }} total</span>
        </div>
        <div class="inventory-grid">
          <label>
            <span>Boards</span>
            <input class="form-control" type="number" min="0" name="gaBoards" [(ngModel)]="inventory.gaBoards" [disabled]="!isRoot">
          </label>
          <label>
            <span>Cabinets</span>
            <input class="form-control" type="number" min="0" name="gaCabinets" [(ngModel)]="inventory.gaCabinets" [disabled]="!isRoot">
          </label>
          <label>
            <span>Kiosks</span>
            <input class="form-control" type="number" min="0" name="gaKiosks" [(ngModel)]="inventory.gaKiosks" [disabled]="!isRoot">
          </label>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <button class="btn btn-primary" type="submit" [disabled]="!isRoot || saving">
          <i class="ri-save-line me-1"></i> {{ saving ? 'Saving...' : 'Save Inventory' }}
        </button>
      </div>
    </div>
    </div>
  </form>
</div>
